import LazyDisp from "../class/lazydisp";

const [ w, d ] = [window, document ];

const domReady = () => false;

const jqInit = () => {
  $('.rwd002-breadcrumbs').prependTo( $('.rwd002-detail__entry') );
};

const onLoadHtml = () => {
  // LazyDisp開始
  new LazyDisp('[data-lazydisp]');

  //ローカルナビブロック挿入
  const companyNav = $.get('/src/html/nav-company.html');
  companyNav.done( html => {
    $('.rwd002-detail__entry').append( html );
    $('[data-plugin=currentMenu]').currentMenu({mode:0, default:999});
  });
};

export default function COMPANY () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  $(() => jqInit());
  $(() => Promise.all([w.load['loadHtml']]).then( onLoadHtml ) );
}